import { DisplayPackage } from '../types/revenuecat';

const CACHE_KEY = 'urunn_offerings_cache';
const CACHE_DURATION = 1000 * 60 * 60; // 1 hour in milliseconds

interface CacheData {
  packages: DisplayPackage[];
  timestamp: number;
}

/**
 * Save offerings to cache
 */
export const saveOfferingsToCache = (packages: DisplayPackage[]): void => {
  try {
    const cacheData: CacheData = {
      packages,
      timestamp: Date.now(),
    };
    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
    console.log('Offerings cached successfully:', packages.length, 'packages');
  } catch (error) {
    console.warn('Failed to cache offerings:', error);
  }
};

/**
 * Get offerings from cache if valid
 */
export const getOfferingsFromCache = (): DisplayPackage[] | null => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) {
      console.log('No cached offerings found');
      return null;
    }

    const cacheData: CacheData = JSON.parse(cached);
    const age = Date.now() - cacheData.timestamp;

    if (age > CACHE_DURATION) {
      console.log('Cached offerings expired (age:', Math.round(age / 1000 / 60), 'minutes)');
      clearOfferingsCache();
      return null;
    }

    console.log('Using cached offerings:', cacheData.packages.length, 'packages (age:', Math.round(age / 1000 / 60), 'minutes)');
    return cacheData.packages;
  } catch (error) {
    console.warn('Failed to read offerings from cache:', error);
    clearOfferingsCache();
    return null;
  }
};

/**
 * Clear offerings cache
 */
export const clearOfferingsCache = (): void => {
  try {
    localStorage.removeItem(CACHE_KEY);
    console.log('Offerings cache cleared');
  } catch (error) {
    console.warn('Failed to clear offerings cache:', error);
  }
};

/**
 * Check if cache is valid
 */
export const isCacheValid = (): boolean => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return false;

    const cacheData: CacheData = JSON.parse(cached);
    const age = Date.now() - cacheData.timestamp;

    return age <= CACHE_DURATION;
  } catch (error) {
    return false;
  }
};
